<template>
  <v-container>
    <v-row>
      <v-col>
        <timeseries-config-form />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    TimeseriesConfigForm: () =>
      import('@/components/timeseries/TimeseriesConfigForm')
  }
};
</script>
